export const data = [
  {
    title: "Скільки часу триває процес фарбування та реставрації?",
    answer:
      "Термін обробки залежить від обраного пакету: Mini 5 — до 48 годин, Classic 10 — до 48 годин (пріоритетно) або 24 години за додаткову оплату, Premium 20 — до 72 годин або 24–48 годин у форматі експрес із доплатою. Ми інформуємо вас про хід виконання замовлення в режимі реального часу.",
  },
  {
    title: "У якому форматі надаються готові відео та як їх отримати?",
    answer:
      "Готові відео надаються у форматі Full HD (1080p), сумісному з усіма сучасними пристроями. Ви отримуєте їх через захищене посилання для завантаження з можливістю збереження в хмарному сховищі протягом 6 місяців.",
  },
  {
    title: "Як ви гарантуєте якість фарбування та натуральність кольорів?",
    answer:
      "Ми поєднуємо сучасні технології штучного інтелекту з професійною ручною ретушшю. Для кожного проєкту ми досліджуємо історичний період, щоб досягти максимальної точності кольорів, а також пропонуємо безкоштовні коригування для вашого повного задоволення результатом.",
  },
  {
    title: "Чи можу я обрати музику для свого відео?",
    answer:
      "Так, звичайно. Ми пропонуємо ліцензовану музичну бібліотеку з різними стилями — класичним, сучасним та емоційним. Ви можете обрати бажаний стиль або надіслати власну композицію для використання у відео.",
  },
  {
    title: "Що робити, якщо фотографії сильно пошкоджені?",
    answer:
      "Ми спеціалізуємося на реставрації фотографій будь-якої складності — тріщин, плям, втрачених фрагментів та сильного вицвітання. Кожен випадок ми оцінюємо індивідуально та рекомендуємо оптимальний пакет послуг відповідно до стану ваших знімків.",
  },
];
